import { logger } from "./default-logger";

export function isNavItemActive({ disabled, external, href, matcher, pathname }) {
  // logger.debug('matcher start', matcher, pathname)
  if (disabled || !href || external) {
    return false;
  }

  if (matcher) {

    // if (matcher.type === 'view') {
    //   let path = pathname.replace('@','');
    //   logger.debug('view match', path.startsWith(matcher.appURL) || path.startsWith(matcher.viewURL), path)
    //   return path.startsWith(matcher.appURL) || path.startsWith(matcher.viewURL);
    // }
    
    if (matcher.type === 'regex') {
      // logger.debug('matcher start:', matcher.regex, pathname, pathname.match(matcher.regex))
      return pathname.replace('@','').match(matcher.regex);
    }

    if (matcher.type === 'startsWith') {
      return pathname.startsWith(matcher.href);
    }

    if (matcher.type === 'equals') {
      return pathname === matcher.href;
    }

    return false;
  }

  return pathname === href;
}

